import { render } from "./OvNotesModal.vue?vue&type=template&id=5580e6d3&scoped=true"
import script from "./OvNotesModal.vue?vue&type=script&lang=js"
export * from "./OvNotesModal.vue?vue&type=script&lang=js"

import "./OvNotesModal.vue?vue&type=style&index=0&id=5580e6d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5580e6d3"]])

export default __exports__